/* istanbul ignore file */

import { SVGProps } from 'react';

export function OpenExternalSvg({
  color = '#15161A',
  width = '14',
  height = '14',
  opacity = '0.55',
}: SVGProps<SVGSVGElement>) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
    >
      <path
        id="Intersect"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.3335 0.999996C8.3335 0.631898 8.6319 0.333496 9 0.333496H13C13.3681 0.333496 13.6665 0.631898 13.6665 0.999996V5C13.6665 5.36809 13.3681 5.6665 13 5.6665C12.6319 5.6665 12.3335 5.36809 12.3335 5V2.60907L6.13795 8.80462C5.87767 9.0649 5.45566 9.0649 5.19538 8.80462C4.93509 8.54433 4.93509 8.12233 5.19538 7.86204L11.3909 1.6665H9C8.6319 1.6665 8.3335 1.36809 8.3335 0.999996ZM2.33333 3.6665C2.15647 3.6665 1.98686 3.73675 1.86181 3.86181C1.73675 3.98686 1.6665 4.15647 1.6665 4.33333V11.6667C1.6665 11.8435 1.73675 12.0131 1.86181 12.1382C1.98686 12.2632 2.15647 12.3335 2.33333 12.3335H9.66666C9.84352 12.3335 10.0131 12.2632 10.1382 12.1382C10.2632 12.0131 10.3335 11.8435 10.3335 11.6667V7.66666C10.3335 7.29857 10.6319 7.00016 11 7.00016C11.3681 7.00016 11.6665 7.29857 11.6665 7.66666V11.6667C11.6665 12.1971 11.4558 12.7057 11.0808 13.0808C10.7057 13.4558 10.1971 13.6665 9.66666 13.6665H2.33333C1.80294 13.6665 1.29427 13.4558 0.919234 13.0808C0.544192 12.7057 0.333496 12.1971 0.333496 11.6667V4.33333C0.333496 3.80294 0.544192 3.29428 0.919234 2.91923C1.29428 2.54419 1.80294 2.3335 2.33333 2.3335H6.33333C6.70143 2.3335 6.99983 2.6319 6.99983 3C6.99983 3.36809 6.70143 3.6665 6.33333 3.6665H2.33333Z"
        fill={color}
        fillOpacity={opacity}
      />
    </svg>
  );
}
